import React, { FunctionComponent } from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { moderateScale, scale } from 'react-native-size-matters';
import heartRateNotFoundIcon from '../../assets/images/hr-notfound.svg';
import Theme from '../../theme';
import { SVGIcon } from '../../ui';

interface IProps {
  onPress: () => void;
}

export const HeartRateMonitorButton: FunctionComponent<IProps> = ({ onPress, children }) => (
  <TouchableOpacity style={styles.button} onPress={onPress}>
    {children}
    <SVGIcon Icon={heartRateNotFoundIcon} style={styles.heartRateIcon}/>
  </TouchableOpacity>
);

export const ConnectHRMonitorButton: FunctionComponent<IProps> = ({ onPress }) => (
  <HeartRateMonitorButton onPress={onPress}>
    { false && <View style={styles.textContainer}>
      <Text style={styles.text}>CONNECT YOUR</Text>
      <Text style={styles.text}>HEART RATE MONITOR</Text>
    </View>}
  </HeartRateMonitorButton>
);

export const WaitingForHRMonitorButton: FunctionComponent<IProps> = ({ onPress }) => (
  <HeartRateMonitorButton onPress={onPress}>
    <View style={styles.textContainer}>
      <Text style={styles.text}>WAITING FOR</Text>
      <Text style={styles.text}>HEART RATE MONITOR</Text>
    </View>
  </HeartRateMonitorButton>
);

export const SetupHRMonitorButton: FunctionComponent<IProps> = ({ onPress }) => (
  <HeartRateMonitorButton onPress={onPress}>
     <View style={styles.textContainer}>
      <Text style={styles.text}>SETUP</Text>
      <Text style={styles.text}>HEART RATE MONITOR</Text>
    </View>
  </HeartRateMonitorButton>
);

const styles = StyleSheet.create({
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 20,
    marginRight: scale(5),
  },
  text: {
    fontSize: moderateScale(10),
    paddingLeft: 10,
    color: Theme.GREY_DARK_MEDIUM,
    fontFamily: Theme.Custom700,
    textAlign: 'right',
  },
  textContainer: {
    marginBottom: 0,
    paddingTop: moderateScale(4),
  },
  waitingForHr: {
    fontSize: 12,
  },
  heartRateIcon: {
    height: moderateScale(40),
    width: moderateScale(40),
    marginHorizontal: 10,
  },
});
